import { render, staticRenderFns } from "./LastProducts.vue?vue&type=template&id=304784ac&"
import script from "./LastProducts.vue?vue&type=script&lang=js&"
export * from "./LastProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports